import { DietType } from '@calo/types';
class FoodService {
    getDiet(food) {
        const diets = Object.values(DietType);
        return (food.tags || []).find(t => diets.includes(t)) || DietType.balanced;
    }
}
export default new FoodService();
